




















import Vue, { PropType } from 'vue';
import {
  Option,
} from 'mostra';

export default Vue.extend({
  name: 'booth-display-type-form',
  props: {
    value: {
      type: Number,
      required: true,
    },
    name: {
      type: String as PropType<string>,
      required: true,
    },
    options: {
      type: Array as PropType<Option>,
      required: true,
    },
  },
  computed: {
    innerValue: {
      get(): number {
        return this.value;
      },
      set(val: number): void {
        this.$emit('input', val);
      },
    },
  },
});
